import { Component, OnInit, Input } from '@angular/core';
import { WorkflowExecutionState } from '@enums/workflow-execution-state.enum';

@Component({
    selector: 'app-execution-state',
    templateUrl: './execution-state.component.html',
    styleUrls: ['./execution-state.component.scss']
})
export class ExecutionStateComponent implements OnInit {
    @Input() state: WorkflowExecutionState;
    @Input() compact: boolean;
    WorkflowExecutionState = WorkflowExecutionState;

    constructor() { }

    ngOnInit() {
    }

    getStateClass(state: WorkflowExecutionState): string {
        return state.toString().toLowerCase();
    }


}
